export const getRetinaRatio = (d, b) => {
  const devicePixelRatio = d ? d : getDeviceRatio()
  const backingStoreRatio = b ? b : getBackingStoreRatio()

  return devicePixelRatio / backingStoreRatio
}

export const getDeviceRatio = () => {
  return window && window.devicePixelRatio ? window.devicePixelRatio : 1
}

export const getBackingStoreRatio = () => {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  const backingStoreRatio = [
    ctx.webkitBackingStorePixelRatio,
    ctx.mozBackingStorePixelRatio,
    ctx.msBackingStorePixelRatio,
    ctx.oBackingStorePixelRatio,
    ctx.backingStorePixelRatio,
    1,
  ].reduce((a, b) => {
    return a || b
  })

  canvas.remove()
  return backingStoreRatio
}

export const getStaticPath = (fn, basePath = '') => {
  return `${basePath}${fn}`
}
